import React, { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { Gap } from "../../components/atoms";
import "./routes.css";
// Navigation
import Header from "../../components/molecules/Header";
import SideMenu from "../../components/molecules/SideMenu";
import { LOCAL_STORAGE_KEY } from "../API/config";

// pages
import PageExcoProvinsi from "../../pages/PageExcoProvinsi";
import PageExcoPusat from "../../pages/PageExcoPusat";
import PageExcoKabKot from "../../pages/PageExcoKabKot";
import PageExcoKecamatan from "../../pages/PageExcoKecamatan";
import PageExcoKelurahan from "../../pages/PageExcoKelurahan";
import PageUserManagement from "../../pages/PageUserManagement";
import PageOverview from "../../pages/PageOverview";

// check expired token
import { isJwtExpired } from "jwt-check-expiration";

// profile
import PageProfile from "../../pages/PageProfile";

// login
import PageLogin from "../../pages/PageLogin";

// detail pages
import PageDetailExcoPusat from "../../pages/PageExcoPusat/DetailExcoPusat";
import PageDokumenPusat from "../../pages/PageExcoPusat/DokumenPusat";
// import PageDetailExcoProvinsi from "../../pages/PageExcoProvinsi";

//overview detail
import PageDetailAnggota from "../../pages/PageOverview/DetailAnggota";
import PageDetailPengurus from "../../pages/PageOverview/DetailPengurus";
import PageDetailDokumen from "../../pages/PageOverview/DetailDokumen";

import PageDaftarAnggota from "../../pages/PageDaftarAnggota";

import ReactGA from "react-ga4";
import PageExcoPukIndustri from "../../pages/PageExcoPukIndustri";
ReactGA.initialize("G-FP84G0SEB3");

const PrivateRoute = ({ children }) => {
  const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  let location = useLocation();
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return (
    <>
      <Header />
      <Gap height={35} />
      <SideMenu />
      <div className="content">{children}</div>
    </>
  );
};

const MyRoutes = () => {
  let navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  let getToken = token?.token;
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
    if (getToken) {
      let checkAuth = isJwtExpired(getToken);
      if (checkAuth) {
        localStorage.clear();
        navigate(`/login`);
      }
    }
  }, [navigate, getToken]);
  return (
    <>
      {/* <div className="content"> */}
      <Routes>
        <Route exact path="/login" element={<PageLogin />} />
        <Route
          exact
          path="/"
          element={
            <PrivateRoute>
              <PageExcoPusat />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path="/provinsi"
          element={
            <PrivateRoute>
              <PageExcoProvinsi />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path="/kab-kot"
          element={
            <PrivateRoute>
              <PageExcoKabKot />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path="/kecamatan"
          element={
            <PrivateRoute>
              <PageExcoKecamatan />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path="/kelurahan"
          element={
            <PrivateRoute>
              <PageExcoKelurahan />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path="/komisaris-basis"
          element={
            <PrivateRoute>
              <PageExcoPukIndustri />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path="/user-management"
          element={
            <PrivateRoute>
              <PageUserManagement />
            </PrivateRoute>
          }
        />

        {/* Detail Pages */}
        <Route
          exact
          path="/detail-exco-pusat/:officeId/:tingkatExcoId/:daerahId"
          element={
            <PrivateRoute>
              <PageDetailExcoPusat />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path="/dokumen-pusat/:officeId/:tingkatExcoId"
          element={
            <PrivateRoute>
              <PageDokumenPusat />
            </PrivateRoute>
          }
        />

        {/* Profile */}
        <Route
          exact
          path="/profil"
          element={
            <PrivateRoute>
              <PageProfile />
            </PrivateRoute>
          }
        />

        {/* Overview */}
        <Route
          exact
          path="/overview"
          element={
            <PrivateRoute>
              <PageOverview />
            </PrivateRoute>
          }
        />
        {/* Overview Anggota */}
        <Route
          exact
          path="/anggota/:tingkatExcoId/:idProvince/:idCity"
          element={
            <PrivateRoute>
              <PageDetailAnggota />
            </PrivateRoute>
          }
        />
        {/* Overview Pengurus */}
        <Route
          exact
          path="/pengurus/:tingkatExcoId/:idProvince/:idCity"
          element={
            <PrivateRoute>
              <PageDetailPengurus />
            </PrivateRoute>
          }
        />
        {/* Overview Dokumen */}
        <Route
          exact
          path="/dokumen/:tingkatExcoId/:idProvince/:idCity"
          element={
            <PrivateRoute>
              <PageDetailDokumen />
            </PrivateRoute>
          }
        />
        {/* Daftar Anggota */}
        <Route
          exact
          path="/daftar-anggota/:tingkatExcoId/:idDaerah/:namaDaerah"
          element={
            <PrivateRoute>
              <PageDaftarAnggota />
            </PrivateRoute>
          }
        />
      </Routes>
      {/* </div> */}
    </>
  );
};

export default MyRoutes;
